module.exports = "https://qp-assets.quero.com/assets/images/icons/i-close.svg?711986421e0d3e80fc42e6d3d2ccd45a";